/**
 * A table that sits inside one tile (ADR 0029).
 *
 * The tile already pads its content (`ps-5 pe-4`), so the table pulls itself
 * back to the tile's edges and gives that inset to its first and last cells.
 * Rules and hover rows then run edge to edge like list rows, and the first
 * column's text aligns with the tile's header. Header cells read quiet from the
 * kit's TableHead; cells keep `text-ui tabular-nums`.
 */
import type { ComponentProps } from "react";

import { Table } from "@/components/ui/table";
import { cn } from "@/lib/utils";

export function TileTable({ className, ...props }: ComponentProps<typeof Table>) {
  return (
    <div className="-ms-5 -me-4 min-w-0">
      <Table
        className={cn(
          "[&_th:first-child]:ps-5 [&_td:first-child]:ps-5 [&_th:last-child]:pe-4 [&_td:last-child]:pe-4",
          className,
        )}
        {...props}
      />
    </div>
  );
}
